import * as yup from "yup";

export const superUserValidationSchema = yup.object().shape({
  phone_number: yup
    .number()
    .typeError("Please enter your phone number")
    .required("Please enter your phone number")
    .test(
      "len",
      "Please enter your phone number",
      (val) => val.toString().length === 10
    ),
  user_name: yup.string().required("Please enter User Name"),
  email_address: yup
    .string()
    .required("Please enter email address")
    .email("Please enter a valid email"),
  status: yup
    .string()
    .required("Please select User Status")
    .trim("Please select User Status"),
});
export const userValidationSchema = yup.object().shape({
  organization_code: yup.string().required("Select Organization Code"),
  phone_number: yup
    .number()
    .typeError("Please enter your phone number")
    .required("Please enter your phone number")
    .test(
      "len",
      "Please enter your phone number",
      (val) => val.toString().length === 10
    ),
  user_name: yup.string().required("Please enter User Name"),
  corporation_code: yup.string().required("Select Corporation Code"),
  email_address: yup
    .string()
    .required("Please enter email address")
    .email("Please enter a valid email"),
  status: yup
    .string()
    .required("Please select User Status")
    .trim("Please select User Status"),
});

export const locationValidationSchema = yup.object().shape({
  organization_code: yup.string().required("Please select Organization Code"),
  location_name: yup
    .string()
    .required("Please enter your Location name")
    .trim("Please enter your Location name"),
  zip_code: yup
    .string()
    .required("Please enter your Zip code")
    .trim("Please enter your Zip code"),
  location_id: yup
    .string()
    .required("Please enter your Location id")
    .trim("Please enter your Location id"),
});

export const productValidationSchema = yup.object().shape({
  sku: yup.string().required("Please prodvide SKU").trim(),
  product_name: yup
    .string()
    .required("Please enter Product name")
    .trim("Please enter Product name"),
  expiry: yup
    .number()
    .typeError("Please enter your expiry")
    .integer("Please enter valid expiry")
    .required("Please enter your expiry")
    .min(1, "Please enter valid expiry"),
  product_status: yup
    .string()
    .required("Please select status")
    .trim("Please select status"),
});
export const searchOrderValidationSchema = yup.object().shape({
  sku: yup.string().required("Please provide SKU"),
});

export const corporationValidationSchema = yup.object().shape({
  corporation_name: yup
    .string()
    .required("Please enter Corporation Name")
    .trim("Please enter Corporation Name"),
  corporation_code: yup
    .string()
    .required("Please enter Corporation Code")
    .trim("Please enter Corporation Code"),
  address_line_one: yup
    .string()
    .required("Please enter Address")
    .trim("Please enter Address"),
  country: yup
    .string()
    .required("Please select Country")
    .trim("Please select Country"),
  state: yup.string().required("").trim(""),
  city: yup.string().required("").trim(""),
  pincode: yup
    .string()
    .required("Please enter Zipcode")
    .trim("Please enter Zipcode"),
});
export const organizationValidationSchema = yup.object().shape({
  corporation_code: yup
    .string()
    .required("Please select Corporation Code")
    .trim("Please enter Corporation Code"),
  organization_name: yup
    .string()
    .required("Please enter Organization Name")
    .trim("Please enter Organization Name"),
  organization_code: yup
    .string()
    .required("Please enter Organization Code")
    .trim("Please enter Organization Code"),
  address_line_one: yup
    .string()
    .required("Please enter Address")
    .trim("Please enter Address"),
  country: yup
    .string()
    .required("Please select Country")
    .trim("Please select Country"),
  state: yup.string().required("").trim(""),
  organization_status: yup
    .string()
    .required("Please select Status")
    .trim("Please select Status"),
  city: yup.string().required("").trim(""),
  pincode: yup
    .string()
    .required("Please enter Zipcode")
    .trim("Please enter Zipcode"),
});

export const configurationValidationSchema = yup.object().shape({
  escalation_threshold_days: yup
    .number()
    .typeError("Please enter a valid number")
    .integer("Please enter a whole number")
    .required("Escalation threshold is required")
    .min(1, "Must be at least 1 day")
    .max(30, "Cannot exceed 30 days"),
});

